import { SxProps, Theme } from "@mui/material";

const styles = {
  "meeting-container": {
    // border: "1px solid #E5E5E5",
    borderRadius: "8px",
    marginRight: "30px",
    position: "relative"
  } as SxProps<Theme>,

  "meeting-tabs": {
    "& .MuiButtonBase-root": {
      margin: "0 10px",
      "@media (max-width: 1200px)": {
        margin: "0 5px",
      },
    },
  } as SxProps<Theme>,

  "meeting-tabs__typography": (isSelected: boolean, theme: Theme): SxProps<Theme> => ({
    fontFamily: 'var(--font-family)',
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "18px",
    letterSpacing: "0px",
    color: isSelected ? "#B902CA" : theme.palette.text.primary,
  }),

  "toggle-switch__container": {
    marginTop: "-5px",
  } as SxProps<Theme>,

  "callout-message": {
    textAlign: "center",
    display: "inline-block",
    padding: "8px 16px",
  } as SxProps<Theme>,

  "meeting-table__container": {
    padding: 0,
    marginTop:"5px",
  } as SxProps<Theme>,

  "meeting-datatable__wrapper": {
    width: "100%",
    marginTop: "-30px",
  } as SxProps<Theme>,

  "interaction-sections": {
    border: "1px solid #E5E5E5",
    borderRadius: "8px",
    backgroundColor: "#FFFFFF",
    height: "calc(100vh - 160px)",
    maxHeight: "calc(100vh - 160px)",
    overflowX: "hidden",
    overflowY: "auto",
    width: "100%",
  } as SxProps<Theme>,

  "interaction-accordion": {
    boxShadow: "none",
    backgroundColor: "#FFFFFF",
    backgroundImage: "none",
    border: "none",
    margin: "0 !important",
    borderRadius: "0 !important",
    height: "auto",
    overflow: "visible",
    "&:before": {
      display: "none",
    },
    "&.Mui-expanded": {
      margin: "0 !important",
    },
    "& .MuiCollapse-root": {
      height: "auto !important",
      overflow: "visible !important",
    },
    "& .MuiCollapse-wrapper, & .MuiCollapse-wrapperInner": {
      height: "auto",
    },
  } as SxProps<Theme>,

  "interaction-accordion--pinned": {
    position: "sticky",
    top: 0,
    height: "100%",
    maxHeight: "100%",
    zIndex: 2,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    backgroundColor: "#FFFFFF",
    "& .MuiAccordionSummary-root": {
      flexShrink: 0,
      backgroundColor: "#FFFFFF",
    },
    "& .MuiCollapse-root": {
      flex: "1 1 auto",
      minHeight: "0 !important",
      height: "unset !important",
      overflow: "hidden !important",
    },
    "& .MuiCollapse-wrapper, & .MuiCollapse-wrapperInner": {
      height: "100% !important",
    },
    "& .MuiAccordionDetails-root": {
      height: "100%",
      minHeight: 0,
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
    },
  } as SxProps<Theme>,

  "interaction-accordion__summary": {
    minHeight: "48px !important",
    margin: "10px 10px 0px 10px",
    border: "none",
    "& .MuiAccordionSummary-content": {
      margin: "12px 0 !important",
    },
    "&:hover": {
      backgroundColor: "#F2F2F4",
    },
  } as SxProps<Theme>,

  "interaction-accordion__title": {
    fontFamily: "var(--font-family)",
    fontWeight: 500,
    color: "#34343D",
    fontSize: "15px",
    lineHeight: "100%",
  } as SxProps<Theme>,

  "interaction-accordion__count": {
    fontWeight: 400,
    fontStyle: "normal",
    fontSize: "13px",
    lineHeight: "100%",
    letterSpacing: "0.1em",
    color: "#9595A3",
  } as SxProps<Theme>,

  "interaction-accordion__details": {
    padding: 0,
    paddingLeft: "10px",
    overflow: "visible",
    border: "none",
  } as SxProps<Theme>,

  "interaction-accordion__table": {
    width: "100%",
    maxWidth: "100%",
    overflow: "hidden",
    "& .MuiPaper-root": {
      boxShadow: "none",
      width: "100%",
      maxWidth: "100%",
      overflow: "hidden",
    },
    "& .MuiTableContainer-root": {
      width: "100%",
      maxWidth: "100%",
      overflowX: "auto",
      minHeight: "0 !important",
      marginLeft: "20px !important",
    },
  } as SxProps<Theme>,

  "interaction-accordion__table--bounded": {
    "& .MuiTableContainer-root": {
      overflow: "auto !important",
      maxHeight: "calc(100vh - 340px) !important",
      marginLeft: "20px !important",
    },
  } as SxProps<Theme>,

  "interaction-accordion__table--fill": {
    flex: "1 1 auto",
    minHeight: 0,
    height: "100%",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    "& .MuiPaper-root": {
      flex: "1 1 auto",
      minHeight: 0,
      height: "100%",
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
    },
    "& .MuiTableContainer-root": {
      flex: "1 1 auto",
      minHeight: "0 !important",
      height: "auto !important",
      maxHeight: "calc(100vh - 330px) !important",
      overflowX: "auto !important",
      overflowY: "auto !important",
    },
  } as SxProps<Theme>,

  "interaction-accordion__empty": {
    padding: "16px 36px",
    fontFamily: "var(--font-family)",
    fontSize: "13px",
    lineHeight: "18px",
    color: "#6F6F7F",
  } as SxProps<Theme>,

  "interaction-accordion__expandImg": {
    width: "9px",
    height: "11px",
    color: "#9595A3",
    filter:
      "brightness(0) saturate(100%) invert(44.3%) sepia(29.6%) saturate(221.2%) hue-rotate(201.5deg) brightness(158%) contrast(36%)",
  } as SxProps<Theme>,

  "interaction-accordion__collapseImg": {
    width: "11px",
    height: "9px",
    color: "#33333B",
    filter:
      "brightness(0) saturate(100%) invert(8.1%) sepia(44.9%) saturate(531.6%) hue-rotate(201.4deg) brightness(71.3%) contrast(68.2%)",
  } as SxProps<Theme>,

};

export default styles;
